import { writable } from "svelte/store";

function readBoolFromStorage(key, defaultValue = null) {
    const ret = localStorage.getItem(key);
    if (ret === null) {
        return defaultValue;
    }
    return ret === "true";
}

export const debug = process.env.DEBUG;
export const redHost = process.env.TEMPLATE_URL_RED;
export const blueHost = process.env.TEMPLATE_URL_BLUE;
export const goldHost = process.env.TEMPLATE_URL_GOLD;
export const cesHost = process.env.TEMPLATE_URL_CES;
export const lotoHost = process.env.TEMPLATE_URL_LOTO;
export const arenaHost = process.env.TEMPLATE_URL_ARENA;
export const tadjHost = process.env.TEMPLATE_URL_TADJ;
export const kenoHost = process.env.TEMPLATE_URL_KENO;
export const hosts = [goldHost, redHost, blueHost, null, cesHost, arenaHost, tadjHost, kenoHost];

export const apiHost = process.env.API_HOST + "/";
export const isOfferVisible = writable(readBoolFromStorage('offer', true));
export const isScreenSaverVisible = writable(false);
export const token = writable(localStorage.getItem('token'));
export const balance = writable(0);
export const denominations = writable([1]);
export const denomination = writable(1);
export const jackpots = writable(null);
export const isOut = writable(0);
export const historyState = writable(0);
export const historyPage = writable(0);
export const historyData = writable([]);
export const games = writable([]);
export const terminalNumber = writable("");
export const offer = writable(3);

let denominationValue = 10;
denomination.subscribe(v => denominationValue = v);
let terminalNumberValue = "";
terminalNumber.subscribe(v => terminalNumberValue = v);

export function fetchHistory(apiHost, historyPage, token) {
    historyData.set([]);
    fetch(`${apiHost}v1/history/${historyPage}/10`, {
        headers: new Headers({
            Authorization: "Bearer " + token,
        }),
    })
        .then((r) => r.json())
        .then((r) => {
            if (r.success && r.data) {
                historyData.set(r.data);
            }
        });
}

function updateJackpot(data) {
    if (data[0] === 'change-jackpot') {
        jackpots.update((old) => {
            old[['bronze', 'silver', 'gold', 'dimond'][data[1]]] = 0.7 * data[2] | 0;
            console.log(old, data)
            return old;
        })
    }
}

export function pusherConnector(id, key, cluster, authEndpoint, tokenValue) {
    const pusher = new Pusher(key, {
        cluster: cluster,
        forceTLS: true,
        authEndpoint: authEndpoint,
        auth: {
            headers: {
                Authorization: `Bearer ${tokenValue}`,
            },
        }
    });
    const channel = pusher.subscribe(`private-player-${id}`);
    channel.bind("change-player", function (data) {
        if ("balance" in data) {
            balance.set(data.balance);
            if (data.balance === 0) {
                if (!terminalNumberValue.length || terminalNumberValue[0] !== "0") {
                    isScreenSaverVisible.set(true);
                }
                isOfferVisible.set(true);
            }
        }
        if ("is_out" in data) {
            isOut.set(data.is_out);
        }
        if ("status" in data && data.status === 0) {
            localStorage.removeItem('token');
            token.set(null);
            window.location.reload();
        }
        if ("cmd" in data) {
            if (data.cmd === "reload" || data.cmd === "home") {
                window.location.reload();
            }
        }
    });
    channel.bind('action-player', function (data) {
        console.log(data)
        if (Array.isArray(data) && data.length > 0) {
            if (data[0] === 'change-jackpot') {
                updateJackpot(data);
            } else if (Array.isArray(data[0])) {
                data.forEach(e => {
                    if (e[0] === 'change-jackpot') {
                        updateJackpot(e);
                    }
                })
            }
        }
    });
}
